export default defineNuxtPlugin(() => {
  const { isIntegrationEnabled, disableIntegration } = useUtils()

  if (!isIntegrationEnabled('googlePlaces')) disableIntegration('installernet')
  if (!isIntegrationEnabled('installernet')) return

  const quotes = reactive(new Map<string, string>())

  function getQuote(sku: string) {
    return quotes.get(sku)
  }

  function setQuote(sku: string, quoteId?: string) {
    if (quoteId) quotes.set(sku, quoteId)
    else quotes.delete(sku)
  }

  function clearQuotes() {
    quotes.clear()
  }

  return {
    provide: {
      installernet: {
        getQuote,
        setQuote,
        clearQuotes,
      },
    },
  }
})
